import './Advertisement.js';
import React from 'react';

function Advertisement() {
  return (
    <div id="advertisement">
        <hr/>
      Submitted and coded by Jagadeesh Kumar . S, you may send mail to my email address which is jagadeesh_2k17@proton.me and you may contribute some money to my Indian Unified Payment Interface (UPI) which is jagadeesh-kumar@ybl .
        <hr/>
    </div>
  );
}

export default Advertisement;